<script>
	import { fade } from 'svelte/transition';
</script>

<div class="spinner" transition:fade>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background-image: none; display: block; shape-rendering: auto; background-position: initial initial; background-repeat: initial initial;" width="32px" height="32px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
		<circle cx="50" cy="50" fill="none" stroke="#c69a50" stroke-width="8" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
			<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
		</circle><!-- [ldio] generated by https://loading.io/ -->
	</svg>
</div>
